import {Acronyms,Citations} from './expandables'
import React from 'react'
import Acronym from 'components/interactive/acronym'
import Citation from 'components/interactive/citation/citation'
import ProfileImg from 'pages/june-5/races/images/villaraigosa.png'
import ProfileImg_w from 'pages/june-5/races/images/villaraigosa.webp'
import prevCandImg from 'pages/june-5/races/images/cox.png'
import nextCandImg from 'pages/june-5/races/images/allen.png'


const Data = {
	pageId: "state-race-cand-antonio-villaraigosa",
	meta: {
		canonicalUrl:"https://bythebya.cool/election/state-race-cand-antonio-villaraigosa",
		documentTitle:"Antonio Villaraigosa • CA June 5, 2018 Election",
		socialHeadline:"Antonio Villaraigosa wants to be Governor of CA",
		socialDescription:"A nonpartisan breakdown of what he's done, his campaign promises, and controversies.",
		socialImage:"https://s3-us-west-1.amazonaws.com/bythebay.cool/socialimages/howtopassalaw.png",
	},
	intro: {
		candidateName: "Antonio Villaraigosa",
		img: {
			_1x_webp: ProfileImg_w,
			_1x: ProfileImg,
		}, 
		color: "mint",
		summary: [
			{
				label: "Running for",
				value: "Governor of California",
			},
			{
				label: "Party",
				value: "Democrat",
			},
			{
				label: "Current Role",
				value: "Public Policy Advisor",
			},
			{
				label: "Past roles",
				value: "Mayor of Los Angeles (2005-13)",
			},
			{
				label: "Fundraised",
				value: <span role="img" aria-label="amount fundraised">
					💸 💸 💸 💸 💸 <Citation data={Citations["1"]}>($34.5M as of 6/4/18)</Citation>
				</span>,
			},
			{
				label: "Did you know/Fun fact",
				value: "He grew up in LA. Raised by a single mother. He was a union organizer. Divorced his first wife after an affair as Mayor of LA.",
			},
		],
		highlightSection: {
			title: "The latest",
			body: "Gubernatorial candidate John Chiang recently launched an attack ad critcizing Antonio's fiscal record as LA mayor.",
			link: "http://www.latimes.com/politics/essential/la-pol-ca-essential-politics-may-2018-chiang-attacks-villaraigosa-s-record-as-1526156938-htmlstory.html",
		},
		raceInfo: {
			position: "California Governor",
			link: "/election/state-race-governor",
			opponents: [
				{
					name: "Gavin Newsom (D)",
					link: "/election/state-race-cand-gavin-newsom",
				},
				{
					name: "John Cox (R)",
					link: "/election/state-race-cand-john-cox",
				},
				{
					name: "Travis Allen (R)",
					link: "/election/state-race-cand-travis-allen",
				},
				{
					name: "John Chiang (D)",
					link: "/election/state-race-cand-john-chiang",
				},
				{
					name: "Delaine Eastin (D)",
					link: "/election/state-race-cand-delaine-eastin",
				},
			]
		}
	},
	sections: [
		{
			id: "010",
			type: "summary-list",
			data: {
				title: "Campaign Promises",
				subtitle: "What Antonio says he'll do once he's governor",
				stories: [
					{
						title: <span><Citation data={Citations["2"]}>Rethink one-size-fits-all approach to economic policy</Citation></span>,
						description: 
							<ul>
								<li>Restore the ability for local governments to keep local funds</li>
								<li>Give cities the ability to adapt regulations to local realities </li>
								<li>Empower local jurisdictions to act as regional economies </li>
							</ul>,
					},
					{
						title: <span><Citation data={Citations["3"]}>Apply a student-focused lens to CA's education system</Citation></span>,
						description: 
							<ul>
								<li>Invest in more compensation, training, and tenure reform for teachers</li>
								<li>Empower low-income families to pay for charter or public schools</li>
							</ul>,
					},
					{
						title: "Reform Community Redevelopment Agencies to invest billions into housing",
						description: 
							<ul>
								<li>Reform permitting laws such as <Acronym data={Acronyms.CEQA}/></li>
								<li>Establish a $10<Acronym data={Acronyms.B}/> fund to help property owners build Accessory Dwelling Units</li>
								<li>Create regional housing trust funds so cities share the load of investing in housing</li>
							</ul>,
					},
					{
						title: <span><a target="_blank" rel="noopener noreferrer" href="https://antonioforcalifornia.com/issues/">Read more on his campaign website</a></span>,
					},
				],
			},
		},	

		{
			id: "020",
			type: "video-carousel",
			data: {
				title: "Watch Antonio Villaraigosa talk",
				subtitle: <span>It's not him <Acronym data={Acronyms.IRL}/>, but it's close</span>,
				videos: [
					{
						caption: "KQED interview (March 2017)",
						link:"https://www.youtube-nocookie.com/embed/qmFf3Pv3L7M?start=1178",
					},
					{
						caption: "KPIX interview (May 2018)",
						link:"https://www.youtube-nocookie.com/embed/OGk5GbihTiA",
					},
					{
						caption: "Villaraigosa on housing (March 2018)",
						link:"https://www.youtube-nocookie.com/embed/GwviEiPjtLc",
					},
					{
						caption: "KTLA Villaraigosa on Sanctuary State (Jan 2018)",
						link:"https://www.youtube-nocookie.com/embed/UIWFT9JtAVw",
					},
					{
						caption: "Hour Conversation with PPIC (June 2017)",
						link:"https://www.youtube-nocookie.com/embed/1H-0NjlZ2jo",
					},
					{
						caption: "Question about Herbalife (Jan 2018)",
						link:"https://www.youtube-nocookie.com/embed/NWRuP4YfqNs",
					},
				],
			},
		},
		{
			id: "030",
			type: "summary-list",
			data: {
				title: "Stuff Antonio has done",
				subtitle: "Some of the policies he's passed",
				stories: [
					{
						title: "Founded 'The Partnership for LA Schools,' an effort to transform LA's lowest performing schools (2008)",
						description: <span><Citation data={Citations["5"]}>As LA Mayor, Antonio partnered with <Acronym data={Acronyms.LAUSD}/> to raise more than $72M for public schools</Citation></span>,
					},
					{
						title: "Passed Measure R, a sales tax to fund public transit projects (2008)",
						description: <span><Citation data={Citations["6"]}>Antonio fundraised and campaigned for the successful ballot measure that is expected to raise $35<Acronym data={Acronyms.B}/> for LA public transit projects</Citation></span>,
					},
					{
						title: <span><a target="_blank" rel="noopener noreferrer" href="https://antonioforcalifornia.com/history-and-accomplishments/">Learn more on his campaign website</a></span>,
						description: null,

					},
				],
			},
		},
		{
			id: "040",
			type: "photo-carousel",
			data: {
				title: "Politicians are \"people\" too",
				subtitle: "Highlights from Antonio's public",
				socialMedia: [
					{
						label: "Twitter",
						link: "https://twitter.com/antonio4ca",
					},
						{
						label: "Instagram",
						link: "https://www.instagram.com/antonioforcalifornia/",
					},
					{
						label: "Facebook",
						link: "https://www.facebook.com/AntonioVillaraigosa/",
					},
				],
				images: [
					{
						src: "https://scontent-sjc3-1.cdninstagram.com/vp/42d05dda712e41bedb605d60cfa6e17f/5B9269EB/t51.2885-15/e35/18013456_405884923125561_5635877595007418368_n.jpg",
						caption: "Volunteering in the city",
						link:"https://www.instagram.com/p/BTZ3TEAjiKH/?taken-by=antonioforcalifornia"
					},
					{
						src: "https://scontent-sjc3-1.xx.fbcdn.net/v/t31.0-8/27982882_1657526424283889_3248050361306207300_o.jpg?_nc_cat=0&_nc_eui2=AeHYLLuEDZH6hftkmRdm7gvLpUrzwEPeqnl1opOUxV8t7xeA5Oeuzv6GGfvT-m3Z91QnT3MGIY1cLROFiajbc2Wtcb7hLy3X0te93U636pm8IA&oh=bc5fe985f9132f217a226c86b24591a9&oe=5B8F88A5",
						caption: "Holding a baby",
						link:"https://www.facebook.com/AntonioVillaraigosa/photos/a.407863302583547.82176.387765724593305/1657526424283889/?type=3&theater",
					},
					{
						src: "https://scontent-sjc3-1.xx.fbcdn.net/v/t31.0-8/21414891_1514009878635545_2893582644627933934_o.jpg?_nc_cat=0&_nc_eui2=AeF2GDHkw4pfY-fJ3a6Iw7yCgRE88T66xjJwyapxG31vaEAUqlJfSEkttP-e8_DX1Ebcu0pYPbGnSLDBvPBLJGwe8g5vTGvtoK9HSYhOxOArrQ&oh=b8d5c80a5f90d0ce25b359f1346fe62c&oe=5B7CC4CC",
						caption: "Reading to children",
						link:"https://www.facebook.com/AntonioVillaraigosa/photos/a.407863302583547.82176.387765724593305/1514009878635545/?type=3&theaterr",
					},
				],
			},
		},
		{
			id: "050",
			type: "endorsements-list",
			data: {
				title: "Lovers & Haters",
				subtitle: "What people say about Antonio",
				lovers: [
					{
						author: "LA Times Editorial Board",
						quote: "The reason to vote for him is that having served successfully as a legislative leader in Sacramento and as mayor during tough times in Los Angeles, he is more prepared for the job than his rivals.",
						link: "http://www.latimes.com/opinion/endorsements/la-ed-governor-endorsement-20180510-story.html",
					},
					{
						author: "United Farm Workers",
						quote: "From his time as a teenage grape boycotter to his work as a union and community organizer to his elected offices as speaker of the Assembly and mayor of Los Angeles to his more recent efforts as an activist, Antonio has marched with farm workers, made appeals to legislators, walked picket lines and used his influence to help farm workers win a better life in all of our important struggles.",
						link: "http://ufw.org/antoniovillaraigosa/",
					},
					{
						author: "San Diego Union Tribune Editorial Board",
						quote: "Villaraigosa not only displayed an effective, judicious management style in persuading his City Council to restrain city spending during a budget-crippling recession; he won voters’ approval for ambitious transportation projects and beefed up his police force. ",
						link: "http://www.sandiegouniontribune.com/opinion/editorials/sd-antonio-villaraigosa-endorsement-for-governor-20180511-story.html",
					},
				],
				haters: [
					{
						author: "Politico Magazine",
						quote: "Villaraigosa’s actual legacy boils down to three things: deep disappointment, unrealized potential and brazen betrayal.",
						link: "https://www.politico.com/magazine/story/2014/03/who-fixed-los-angeles-villaraigosa-legacy-104305",
					},
					{
						author: "Mercury News & East Bay Times Editorial Board",
						quote: "Villaraigosa has experience tackling tough challenges in America’s second-largest city and in Sacramento as Assembly speaker. But he doesn’t exhibit Newsom’s command of the details on what needs to be done next for California and could not explain his political meddling as mayor to block necessary changes to the city retirement system.",
						link: "https://www.mercurynews.com/2018/04/28/editorial-newsom-most-thoughtful-candidate-for-governor/",
					},
					{
						author: "SF Bay Guardian – Tim Redmond",
						quote: "Villaraigosa has a lot of offer, but it’s hard to back someone who was at war with the teachers union in his home town.",
						link: "http://www.sfbg.com/2018/05/02/endorsements-2018/",
					},
				],
			},
		},
		{
			id: "060",
			type: "fundraising-summary",
			data: {
				title: "🤑 Where the money comes from",
				subtitle: "Where Antonio is getting his money, other than himself and outside PACs.",
				sections: [
					{	
						amountRaised: "$34.5M",
						subtitle:"Amount raised as of June 4, 2018",
						fundersTitle: "Top direct donors",
						funders: [
							{
								blurb: "$7,056,400 – Netflix CEO and supporter of charter schools in Los Angeles",
							},
							{
								blurb: "$2,714,800 – Eli and Edythe L. Broad – Philanthropists in the arts and education",
							},
							{
								blurb: "$2,500,000 – Michael Bloomberg – Former New York City mayor",
							},
							{
								blurb: <span>Notable others include Alice Walton, Ryan Seacrest, and Meg Whitman. <a target="_blank" rel="noopener noreferrer" href="http://www.latimes.com/projects/la-pol-ca-california-governor-2018-money/">See more.</a></span>,
							},
						],
					}
				]
			},
		},
		{
			id: "070",
			type: "links-block",
			data:{
				subsections:[
					{
						subsectionTitle: "Controversies",
						links: [
							{
								text:"Villaraigosa and his campaigns have benefited from groups that critics say prey upon the poor, people of color",
								url:"http://www.latimes.com/politics/la-pol-ca-antonio-villaraigosa-herbalife-payday-lenders-donations-20180319-story.html",
							},
							{
								text:"Villaraigosa to pay $123,500 in fines for ethics violations",
								url:"https://www.scpr.org/news/2011/08/02/28019/villaraigosa-pay-ethics-violations-fines/",
							},
							{
								text:"Antonio Villaraigosa was paid $50,000 for a speech in China to promote company later sued by the SEC",
								url:"https://www.mercurynews.com/2018/04/12/antonio-villaraigosa-paid-speeches-california-china/",
							},
						],
					},
					{
						subsectionTitle: "Official links",
						links: [
							{
								text:"Official campaign website",
								url:"https://antonioforcalifornia.com/about-us/"
							},
						],
					},
				],
			}
		},
		{
			id: "080",
			type: "bottom-nav",
			data: {
				tiles: [
					{
						img: prevCandImg,
						to: "/election/state-race-cand-john-cox",
						style: "",
						text: "John Cox",
					},
					{
						img: nextCandImg,
						to: "/election/state-race-cand-travis-allen",
						style: "",
						text: "Travis Allen",
					},
				],
			}
		}
	],
}

export default Data;			





// WEBPACK FOOTER //
// ./src/pages/june-5/races/data/governor/villaraigosa/data.js